import React from 'react';
import VersionNumber from 'components/atoms/VersionNumber';
import { BuyAGiftVoucher, DownloadAppListItem, HomeListItem } from './MobileListItems';
import {
  BecomeYourselfListItem,
  BookingsListItem,
  FavoritesListItem,
  MessagesListItem,
  OnboardingListItem,
  PasswordChangeListItem,
  ProfileListItem,
  SignOutListItem
} from './LoggedInListItems';
import {
  AgendaListItem,
  DashboardListItem,
  ExploreListItem,
  FinanceInfoListItem,
  HostListItem,
  OffersListItem
} from './HostListItems';
import { AbTestsListItem, AdminListItem, FeatureFlagsListItem } from './AdminListItems';
import { ConsentListItem, HelpListItem, PhoneListItem } from './ListItems';
import { LoginListItem, SignUpListItem } from './UnLoggedListItems';
import { CurrencyListItem, LanguageListItem } from './SelectListItems';
import { UrlHelper } from 'hoc/UrlHelper';
import { openExternalLink } from 'utils/openExternalLink';
import useCandidateProcess from 'hooks/useCandidateProcess';
import { signOut } from 'modules/authentication/helpers/nextauth';

const CSS = require('./NavbarList.less');

interface NavbarListProps {
  onClick: () => void;
  isMobile?: boolean;
  isHost?: boolean;
}

const isExploreAsGuest = () => {
  try {
    return sessionStorage.getItem('no-host-redirect');
  } catch (e) {
    return false;
  }
};

function NavbarList({ onClick, isMobile }: NavbarListProps) {
  const { isCandidate } = useCandidateProcess();
  const onLogoutClick = (redirectUrl) => {
    signOut(redirectUrl ?? window.location.href);
  }
  const onProfileClick = () => {
    const url = UrlHelper.url('/account/', false);
    return openExternalLink(url);
  }
  const onBecomeYourself = () => {
    window.location.href = `${URL_STOREFRONT_HOST}/storefront-admin/unspy/?callbackUrl=${window.location.href}`;
  }

  return (
    <ul className={CSS.Menu}>
      <HomeListItem onClick={onClick} />
      <DashboardListItem onClick={onClick} />
      {isCandidate && <OnboardingListItem onClick={onClick} />}
      <AgendaListItem onClick={onClick} />
      <FinanceInfoListItem onClick={onClick} />
      <DownloadAppListItem onClick={onClick} />
      <LoginListItem onClick={onClick} />
      <SignUpListItem onClick={onClick} />
      <BecomeYourselfListItem onClick={onClick} onBecomeYourself={onBecomeYourself} />
      <ProfileListItem onClick={onClick} onProfileClick={onProfileClick} />
      <MessagesListItem onClick={onClick} isMobile={isMobile} />
      <BookingsListItem onClick={onClick} isMobile={isMobile} />
      {!isCandidate && <HostListItem onClick={onClick} />}
      <OffersListItem onClick={onClick} />
      {!isExploreAsGuest() && <ExploreListItem onClick={onClick} isCandidate={isCandidate} />}
      <FavoritesListItem onClick={onClick} />
      <HelpListItem onClick={onClick} />
      <AdminListItem onClick={onClick} />
      <PhoneListItem onClick={onClick} />
      <CurrencyListItem />
      <LanguageListItem />
      <PasswordChangeListItem onClick={onClick} />
      <BuyAGiftVoucher onClick={onClick} />
      <ConsentListItem onClick={onClick} />
      <FeatureFlagsListItem onClick={onClick} />
      <AbTestsListItem onClick={onClick} />
      <SignOutListItem onClick={onClick} onLogoutClick={onLogoutClick} />
      <li>
        <VersionNumber hasContent isMobile={isMobile} />
      </li>
    </ul>
  );
}

export default NavbarList;
